import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Badge } from '@awaze/design-system.components.badge';
import { Button } from '@awaze/design-system.components.button';
import { Divider } from '@awaze/design-system.components.divider';
import { FilterControlSettings, ListViewBullets, Map, } from '@awaze/design-system.components.icon';
import { SegmentedControl } from '@awaze/design-system.components.segmented-control';
import { SortOptions, } from '@awaze/design-system.components.sort-options';
import { Stack } from '@awaze/design-system.components.stack';
import { pxToRems } from '@awaze/design-system.utils.react';
import React from 'react';
import styled from 'styled-components';
const StackStyled = styled(Stack) `
  padding: ${pxToRems(16)} 0;
`;
const Join = (controls, separatorFactory) => controls.map((c, i) => (_jsxs(React.Fragment, { children: [i > 0 && separatorFactory(), c] }, i)));
const FilterIcon = styled(FilterControlSettings) `
  display: block;
`;
/**
 * Composition created to be part of the Sticky SearchForm.
 *
 * Showing the Search controls such as Filters, Sorting and Map.
 *
 * (This component is just for the mobile view.)
 */
export const SearchControls = ({ displayMode = null, filtersCount, justify, translations, setDisplayMode, showFilters, sorting, shouldHideSortDisplayText = false, }) => {
    const controls = [];
    if (sorting) {
        controls.push(_jsx(SortOptions, { ...sorting, shouldHideSortDisplayText: shouldHideSortDisplayText }));
    }
    controls.push(_jsx(SegmentedControl, { highlight: true, text: translations.filterTitle, ariaLabel: translations.filterAriaText, badge: _jsx(Badge, { text: filtersCount, variant: "solid" }), icon: _jsx(FilterIcon, { iconColour: "ColorThemeLink" }), variant: ['small', 'medium', 'medium'], onClick: showFilters }));
    return (_jsxs(StackStyled, { isHorizontal: true, justify: justify, children: [Join(controls, () => (_jsx(Divider, { isVertical: true }))), displayMode === 'LIST' && (_jsx(Button, { text: translations.mapTitle, ariaLabel: translations.mapAriaText, icon: _jsx(Map, {}), colourScheme: "brand-secondary", size: "medium", onClick: () => setDisplayMode('MAP') })), displayMode === 'MAP' && (_jsx(Button, { text: translations.listTitle, ariaLabel: translations.listAriaText, icon: _jsx(ListViewBullets, {}), colourScheme: "brand-secondary", size: "medium", onClick: () => setDisplayMode('LIST') }))] }));
};
//# sourceMappingURL=search-controls.js.map